import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    pageSize: 15,
    currentPage: 1,
    url: `/suborganizationlist/`,
    filter_flag: false,
    search: "",
    filters: "",
};

const customerfilterSlice = createSlice({
  name: "customerfilter",
  initialState,
  reducers: {
    setCustomerFilterDataRedux: (state, action) => {
      const {
        pageSize,
        currentPage,
        url,
        filter_flag,
        search,
        filters,
        random
      } = action.payload;

      // Update state with new filter values
      state.pageSize = pageSize;
      state.currentPage = currentPage;
      state.url = url;
      state.filter_flag = filter_flag;
      state.search = search;
      state.filters = filters;
      state.random = random
    },
  },
});

export const { setCustomerFilterDataRedux } = customerfilterSlice.actions;
export default customerfilterSlice.reducer;
